const SCOPE = 'admin-slide-drawer';

export const AdminSlideDrawerTestIds = {
  CLOSE_BUTTON: `${SCOPE}.close-button`,
  CANCEL_BUTTON: `${SCOPE}.cancel-button`,
};
